import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const JSONValidator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [input, setInput] = useState('');
  const [res, setRes] = useState<any>(null);

  const handleProcess = () => {
    try {
      const parsed = JSON.parse(input);
      const formatted = JSON.stringify(parsed, null, 2);
      setRes({ formatted, valid: true });
      onResultChange([{ label: 'Status', value: 'Válido' }, { label: 'Tamanho', value: `${new TextEncoder().encode(formatted).length} bytes` }]);
    } catch (e: any) {
      setRes({ error: e.message, valid: false });
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <FormField label="JSON" value={input} onChange={setInput} type="textarea" placeholder="Cole o JSON aqui..." />
        <div className="flex justify-center my-6">
          <button onClick={handleProcess} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="check-circle" className="w-5 h-5" /> Validar e Formatar</button>
        </div>
        {res && (
          <div className="space-y-4">
            <ResultCard title="Status" value={res.valid ? 'Válido' : 'Inválido'} color={res.valid ? 'green' : 'red'} description={res.error} />
            {res.valid && <textarea value={res.formatted} readOnly className="w-full h-64 p-4 mt-4 bg-theme-input font-mono text-sm rounded-xl border border-theme-border" />}
          </div>
        )}
      </div>
    </div>
  );
};

export default JSONValidator;
